import React, {Component} from 'react';
import { Modal } from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
class ViewModal extends Component {
    state = {
        visible:false,
        title : "",
        summary : "",
        coverPic: "",
        keywords:"",
        content:""
    };

    constructor(props){
        super(props);
    }

    showModal = (record) => {
        this.setState({
            visible:true,
            title : record.title,
            summary : record.summary,
            coverPic: record.coverPic,
            keywords:record.labelNames,
            content:record.content
        })
    };

    closeModal = () =>{
        this.setState({
            visible:false
        })
    };

    render() {
        return (
            <Modal
                title={"查看详情"}
                footer={null}
                visible={this.state.visible}
                onCancel={this.closeModal}
                width={800}
            >
                <Scrollbars style={{height:650}}>
                        <table cellPadding={0} cellSpacing={0} border={0}>
                            <tbody>
                            <tr>
                                {
                                    this.state.coverPic ? <td><img style={{objectFit: "cover", maxWidth: "200px"}} src={this.state.coverPic} height={"100px"}/></td> : <td></td>
                                }
                                <td style={{
                                    padding: "0 10px",
                                    height: "100%",
                                    position: "relative"
                                }} valign={"top"}>
                                    <div style={{
                                        fontSize: 16,
                                        display: '-webkit-box',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'normal',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: '2',
                                    }}
                                         dangerouslySetInnerHTML={{__html: this.state.title}}></div>
                                    <div style={{marginTop:10}}>
                                        <span>关键词:</span>
                                        {
                                            this.state.keywords ? this.state.keywords.map(item =>{
                                                return <span style={{marginLeft: 10}}>{item}</span>
                                            }) : ""
                                        }
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                    <div style={{marginTop: "10px", paddingTop: "10px", borderTop: "1px solid #e8e8e8"}}>
                        <div style={{fontSize: "17px", fontWeight: "bold",marginBottom: 10}}>
                            <span style={{marginRight: "8px", color: "#40a9ff"}}>|</span>
                            <span>摘要</span>
                        </div>
                        <div style={{textIndent: "2em"}} dangerouslySetInnerHTML={{__html: this.state.summary}}></div>
                    </div>

                    <div style={{padding: "10px 0"}}>
                        <div style={{fontSize: "17px", fontWeight: "bold",marginBottom: 10}}>
                            <span style={{marginRight: "8px", color: "#40a9ff"}}>|</span>
                            <span>内容</span>
                        </div>
                        <div style={{textIndex: "2em"}} id={"stuffContent"}
                             dangerouslySetInnerHTML={{__html: this.state.content}}/>
                    </div>
                </Scrollbars>
            </Modal>
        );
    }
}

export default ViewModal;